import { useEffect, useState } from 'react';
import { useDefaultPipelineInformation, useSavedPipelineInformation } from './usePrefilledPipelineInformation';
export const usePipelineInformation = ticketId => {
  const [pipelineInformation, setPipelineInformation] = useState({});
  const {
    defaultPipelineProperty,
    defaultStatusProperty,
    defaultLoading
  } = useDefaultPipelineInformation();
  const {
    savedPipelineProperty,
    savedStatusProperty,
    ticketLoading
  } = useSavedPipelineInformation(ticketId);
  useEffect(() => {
    if ((savedStatusProperty || savedPipelineProperty) && !ticketLoading) {
      setPipelineInformation({
        hs_pipeline: savedPipelineProperty,
        hs_pipeline_stage: savedStatusProperty
      });
      return;
    }
    if ((defaultStatusProperty || defaultPipelineProperty) && !defaultLoading) {
      setPipelineInformation({
        hs_pipeline: defaultPipelineProperty,
        hs_pipeline_stage: defaultStatusProperty
      });
      return;
    }
  }, [defaultPipelineProperty, defaultStatusProperty, savedPipelineProperty, savedStatusProperty, ticketLoading, defaultLoading]);
  return {
    pipelineInformation,
    setPipelineInformation
  };
};